export default __webpack_public_path__ + "img/app-page/Sales.eae5829f9b0e82cce8baa77dc7a6e3c6.png";